<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        Soft drop
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row no-gutters>
          <v-col cols="6">
            <div class="d-flex">
              <div class="d-flex flex-column justify-space-between mr-4">
                <v-menu
                  v-model="date_start_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_start"
                      label="Date start"
                      class="mb-1"
                      readonly
                      hide-details
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_start"
                    @input="date_start_menu = false"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="date_end_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_end"
                      label="Date end"
                      class="mt-1"
                      readonly
                      hide-details
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_end"
                    @input="date_end_menu = false"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="ml-4 d-flex flex-column justify-space-between">
                <v-select
                  v-model="inputMethod"
                  :items="inputMethods"
                  :loading="filtersLoading"
                  label="Input method"
                  class="mb-1"
                  hide-details
                  dense
                  outlined
                />
                <v-select
                  v-model="difficultyLevel"
                  :items="difficultyLevels"
                  :loading="filtersLoading"
                  label="Difficulty level"
                  class="mt-1"
                  hide-details
                  dense
                  outlined
                />
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="d-flex justify-end">
              <v-btn
                color="primary"
                :disabled="filtersLoading"
                @click="apply"
              >
                Apply
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4">
            <v-switch
              v-model="is_player_critical_by_hp"
              :label="`Is player critical by hp: ${is_player_critical_by_hp.toString()}`"
              dense
              hide-details
            />
            <v-switch
              v-model="is_player_critical_by_fp"
              :label="`Is player critical by fp: ${is_player_critical_by_fp.toString()}`"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="4">
            <v-switch
              v-model="immortality"
              label="Does player use Immortality"
              dense
              hide-details
            />
            <v-switch
              v-model="new_game_plus"
              label="New game plus"
              dense
              hide-details
            />
            <v-switch
              v-model="uses_infinite_ammo_in_inventory"
              label="Uses infinite ammo in inventory"
              dense
              hide-details
            />
          </v-col>
        </v-row>
        <v-select
          v-model="selectedMap"
          :items="maps"
          label="Select map"
          hide-details
          outlined
          dense
          @change="updateSelectedEncounters"
        />
        <v-row v-if="showCharts == true">
          <v-col cols="12">
            <v-tabs
              v-model="tab"
            >
              <v-tab
                v-for="item in ['fp', 'hp']"
                :key="item"
              >
                {{ item.toUpperCase() }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <fp-tab-content
                  v-if="tab === 0"
                  ref="fpTabContent"
                  :date_start="date_start"
                  :date_end="date_end"
                  :input_method="inputMethod"
                  :difficulty_level="difficultyLevel"
                  :is_player_critical_by_hp="is_player_critical_by_hp"
                  :is_player_critical_by_fp="is_player_critical_by_fp"
                  :immortality="immortality"
                  :new_game_plus="new_game_plus"
                  :uses_infinite_ammo_in_inventory="uses_infinite_ammo_in_inventory"
                  :selected-encounters="selectedEncounters"
                />
              </v-tab-item>
              <v-tab-item>
                <hp-tab-content
                  v-if="tab === 1"
                  ref="hpTabContent"
                  :date_start="date_start"
                  :date_end="date_end"
                  :input_method="inputMethod"
                  :difficulty_level="difficultyLevel"
                  :is_player_critical_by_hp="is_player_critical_by_hp"
                  :is_player_critical_by_fp="is_player_critical_by_fp"
                  :immortality="immortality"
                  :new_game_plus="new_game_plus"
                  :uses_infinite_ammo_in_inventory="uses_infinite_ammo_in_inventory"
                  :selected-encounters="selectedEncounters"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mdiCalendar } from '@mdi/js';
export default {
  components: {
    fpTabContent: () => import('./soft-drop/fpTabContent.vue'),
    hpTabContent: () => import('./soft-drop/hpTabContent.vue')
  },
  data () {
    return {
      mdiCalendar,
      tab: 0,
      showCharts: false,
      filtersLoading: false,
      date_start_menu: false,
      date_end_menu: false,
      date_start: null,
      date_end: null,
      inputMethod: null,
      inputMethods: ['Keyboard', 'Gamepad'],
      difficultyLevel: null,
      difficultyLevels: [0, 1, 2, 3],
      is_player_critical_by_hp: false,
      is_player_critical_by_fp: false,
      immortality: false,
      new_game_plus: false,
      uses_infinite_ammo_in_inventory: false,
      selectedMap: "All",
      encounters: [],
      selectedEncounters: [],
      maps: []
    }
  },
  async mounted () {
    await this.getEncounters()
  },
  methods: {
    async getEncounters () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/telemetry/encounters`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.encounters = data
        this.selectedEncounters = data.map(encounter => encounter.name)
        this.maps = Array.from(new Set([ 'All', ...data.map(map => map.map_name) ]))
      }
    },
    async apply () {
      if (this.showCharts) {
        if (this.$refs.fpTabContent && this.$refs.fpTabContent.getData) {
          await this.$refs.fpTabContent.getData()
        }

        if (this.$refs.hpTabContent && this.$refs.hpTabContent.getData) {
          await this.$refs.hpTabContent.getData()
        }
      }

      this.showCharts = true
    },
    updateSelectedEncounters (val) {
      if (val === "All") {
        this.selectedEncounters = this.encounters.map(encounter => encounter.name)
      } else {
        this.selectedEncounters = this.encounters
          .filter(encounter => encounter.map_name === val)
          .map(encounter => encounter.name)
      }
    }
  }
}
</script>